<!--说明-->
<!--1.如果传入标准答案answer的话，组件只是用来展示，不会响应用户的选择而改变绑定的value值-->
<!--2.optionFlag表示多选还是单选-->
<template>
  <div class="TopicOptions">
    <div v-if="optionContent.length != 0">
      <ul>
        <li
          class="options"
          @click.prevent="selectOption(option.optionType)"
          :class="{
            active: value.indexOf(option.optionType) != -1 && answer.length == 0
          }"
          :key="option.optionTypeDesc"
          v-for="option in optionContent"
        >
          <div class="option-name">
            <div class="name">{{ option.optionTypeDesc }}</div>
          </div>
          <div class="option-content" v-html="option.optionTextHtml"></div>
        </li>
      </ul>
      <div class="answer" v-if="answer.length != 0">
        <div>我的选择：{{ value.map(r => optionName[r]).join("") }}</div>
        <div>正确答案：{{ answer.map(r => optionName[r]).join("") }}</div>
      </div>
    </div>
    <div class="empty" v-else>暂无选项</div>
  </div>
</template>

<script>
// import { LetterArr } from "@/utils/topic.js";
import { LetterArr } from "@/components/topic/utils/topic";

export default {
  name: "TopicOptions",
  props: {
    optionContent: {
      //选项
      type: Array,
      default: function() {
        return [];
      }
    },
    value: Array, //用户答案
    answer: {
      //标准答案
      type: Array,
      default: function() {
        return [];
      }
    },
    optionFlag: {
      type: Number,
      default: 1 //1单选,其他为多选择
    }
  },
  data: function() {
    return {
      optionName: LetterArr
    };
  },
  methods: {
    selectOption(optionType) {
      if (this.answer.length != 0) {
        //有标准答案展示点击没反应
        return;
      }
      if (1 == this.optionFlag) {
        this.$emit("input", [optionType]);
      } else {
        //多选择
        let userAnswer = [];
        let hasClickVal = false; //当前点击的选择在之前的答案里面
        this.value.forEach(val => {
          if (optionType != val) {
            userAnswer.push(val);
          } else {
            hasClickVal = true;
          }
        });
        if (!hasClickVal) {
          userAnswer.push(optionType);
        }

        this.$emit("input", userAnswer.sort());
      }
    }
  }
};
</script>

<style lang="scss">
.TopicOptions {
  .empty {
    text-align: center;
    padding: 20px;
  }
  .options {
    min-height: 65px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    border-radius: 3px;
    overflow: hidden;
    background: #fcfcfc;
    border: 1px solid rgba(217, 225, 232, 1);
    &.active {
      border: 1px solid rgba(255, 138, 0, 1);
      /*border-image:linear-gradient(0deg, rgba(255,168,0,1), rgba(255,138,0,1)) 10 10;*/
      .name {
        background: linear-gradient(
          0deg,
          rgba(255, 138, 0, 1) 0%,
          rgba(255, 168, 0, 1) 100%
        ) !important;
        color: #fff !important;
      }
    }
    .option-name {
      width: 55px;
      display: flex;
      justify-content: center;
      align-items: center;

      .name {
        width: 24px;
        height: 24px;
        background: #ebf1f7;
        border-radius: 3px;
        color: #98a1ab;
        font-size: 15px;
        text-align: center;
        line-height: 24px;
      }
    }
    .option-content {
      flex: 1;
      padding: 14px;
      display: flex;
      align-items: center;
      overflow-x: auto;
      min-height: 64px;
      border-left: 1px solid #d9e1e8;
      font-size: 15px;
      flex-wrap: wrap;
      video {
        width: 100%;
      }
      img {
        width: 100%;
      }
      audio {
        width: 100%;
      }
      p {
        font-size: 15px;
        margin: 6px 0;
        word-break: break-all;
      }
    }
  }
  .answer {
    width: 100%;
    height: 40px;
    background: #37343d;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 15px;
    color: #fff;
    margin-bottom: 10px;
  }
}
</style>
